var map = {
	"./Arrow_down.svg": 2127,
	"./Arrow_down1.svg": 6198,
	"./Box_light.svg": 556,
	"./Calendar_light.svg": 6996,
	"./Close_round.svg": 1794,
	"./Colum_up_light.svg": 6630,
	"./Cursor.svg": 7883,
	"./Desk_alt_duotone_line.svg": 202,
	"./Done_round_light.svg": 2192,
	"./Group.svg": 626,
	"./Home.svg": 3413,
	"./Home_light.svg": 9807,
	"./Message_light.svg": 8766,
	"./Paperclip.svg": 2378,
	"./Pin_light.svg": 2217,
	"./Polygon.png": 6926,
	"./Send_fill.svg": 2541,
	"./Shape.svg": 2459,
	"./Sort.svg": 8804,
	"./Subtract.svg": 5029,
	"./Time_progress_light.svg": 6510,
	"./Union.svg": 7261,
	"./User_alt_light.svg": 7640,
	"./Vector 9.svg": 4439,
	"./Waterfall.svg": 3193,
	"./Waterfall2.svg": 1757,
	"./Waterfall_light.svg": 3006,
	"./aboutus.png": 2011,
	"./activationcode.png": 6925,
	"./advertisement.png": 461,
	"./album.png": 8021,
	"./appconfig.png": 875,
	"./article.png": 676,
	"./blog.png": 149,
	"./calendar (1) 1.svg": 6282,
	"./categories.png": 4757,
	"./category.png": 5161,
	"./chat 1.svg": 1546,
	"./close-red.png": 607,
	"./close.png": 4856,
	"./comment.png": 8490,
	"./contactus.png": 962,
	"./couple.png": 1447,
	"./customer.png": 2812,
	"./dashboard.png": 5609,
	"./delete.png": 1842,
	"./delete.svg": 2539,
	"./desktop_light.svg": 8781,
	"./discount.png": 1253,
	"./discounttype.png": 9376,
	"./doc.png": 4967,
	"./edit.png": 6722,
	"./edit.svg": 8377,
	"./edit_pencil.svg": 6542,
	"./employee.png": 4783,
	"./expert.png": 895,
	"./expertlocation.png": 2366,
	"./faq.png": 1643,
	"./favorite.png": 8303,
	"./group.png": 6396,
	"./home.png": 3685,
	"./icn_profile.png": 3948,
	"./icn_profile.svg": 7563,
	"./job.png": 134,
	"./location.png": 9766,
	"./log-out.png": 3270,
	"./logout-header.png": 8575,
	"./menu.png": 3643,
	"./message.png": 6592,
	"./music.png": 9692,
	"./news.png": 8736,
	"./newsletter.png": 9168,
	"./no-image.png": 2379,
	"./notification.png": 123,
	"./on-progress.png": 7520,
	"./orange.jpg": 387,
	"./order.png": 6386,
	"./orderdetail.png": 5009,
	"./orderitem.png": 4424,
	"./orderstatus.png": 9850,
	"./parent-menu.png": 3556,
	"./password-hide.png": 9826,
	"./password-show.png": 3391,
	"./permission.png": 1143,
	"./permissions.png": 7238,
	"./person.svg": 340,
	"./phone_light.svg": 4214,
	"./post.png": 1592,
	"./price.png": 6196,
	"./product.png": 2515,
	"./profile-header.png": 2242,
	"./property.png": 1200,
	"./reload.png": 3172,
	"./salary.png": 9302,
	"./salarydetail.png": 5879,
	"./search.png": 5960,
	"./setting.png": 7855,
	"./shop.png": 6354,
	"./slider.png": 1937,
	"./social.png": 2444,
	"./sourceproperty.png": 7739,
	"./tag.png": 3915,
	"./task-header.png": 3096,
	"./task.png": 9635,
	"./tick-blue.png": 9522,
	"./tick.png": 2133,
	"./ticket.png": 181,
	"./tirivel.png": 3610,
	"./title.png": 1380,
	"./user-header.png": 352,
	"./user.png": 856,
	"./video.png": 8869
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;